/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.package').controller('PMSearchFiltersDeliverySectionController', function (
    _,
    $scope,
    PartnerResourceFactory,
    SearchFilterService
) {
	var self = this;

	self.searchCriteria = SearchFilterService.searchCriteria;

    const deliveredStatus = 0;
    const notDeliveredStatus = 1;
    self.deliveredFlagOptions = [
        { label: 'Delivered', value: true, },
        { label: 'Not Delivered', value: false, },
    ];

    if (SearchFilterService.searchCriteria.delivered === true) {
        self.delivered = self.deliveredFlagOptions[deliveredStatus];
    } else if (SearchFilterService.searchCriteria.delivered === false) {
        self.delivered = self.deliveredFlagOptions[notDeliveredStatus];
    } else {
        self.delivered = null;
    }

    self.getPartnerLabel = (partner) => {
        if (typeof partner === 'object') {
            return partner.name;
        }

        return _.find(self.availablePartners, { id: partner }).name;
    };

    PartnerResourceFactory.query({fetchLimit: -1}).$promise.then(function (partners) {
        self.availablePartners = partners;
        self.deliveredToPartners = SearchFilterService.searchCriteria.deliveredToPartners || [];
    });

	$scope.$on('modal.closing', function () {
        SearchFilterService.searchCriteria.delivered = _.get(self.delivered, 'value');
        SearchFilterService.searchCriteria.deliveredToPartners = self.deliveredToPartners;
	});
});
